import React from 'react';
import './HorizontalDivider.scss';

type HorizontalDividerProps = {
  className?: string;
};

export const HorizontalDivider = ({ className = '' }: HorizontalDividerProps) => {
  return <hr className={`horizontal-divider ${className}`} />;
};
